import styles from "./Login.module.css";
import Button from "../../components/components-ui/Button/Button";
import Loading from "../../components/components-ui/Loading/Loading";
import { AuthContext } from "../../Provider/AuthContext";
import { isTokenExpired, logout } from "../../services/auth";
import "react-toastify/dist/ReactToastify.css";
import { toast } from "react-toastify";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

export default function Login() {
  const [showLoading, setShowLoading] = useState(false);
  const {
    signIn,
    idTipoUsuario,
    preposto,
    idDepartamento,
    erro,
    atualizarVersao,
  } = useContext(AuthContext);
  const navigate = useNavigate();
  const expired = isTokenExpired();

  function showAlert(notify, msg) {
    if (notify === 0) {
      toast.success(msg);
    } else {
      toast.error(msg);
    }
  }
  console.log(`Tipo de usuario ${idTipoUsuario}`);
  let path = "";
  // if (preposto === 0) {
  //   if (idTipoUsuario === 5 && idDepartamento === 9) {
  //     path = "/grupo";
  //   } else if (idTipoUsuario === 1) {
  //     path = "/home";
  //   } else if (idTipoUsuario === 3) {
  //     path = "/admin";
  //   } else if (idTipoUsuario === 4) {
  //     path = "/motorista";
  //   } else if (idTipoUsuario === 5) {
  //     path = "/usina";
  //   }
  // }

  const idTipoMenu = localStorage.getItem("tipoMenu");
  console.log("menu " + idTipoMenu);

  if (preposto === 0) {
    if (idTipoMenu == 1) {
      path = "/local";
    } else if (idTipoMenu == 2) {
      path = "/usina";
    }
  }

  if (preposto === 1) {
    if (idTipoUsuario === 1) {
      path = "/prep/home/";
    }
    if (idTipoUsuario === 3) {
      path = "/prep/admin/";
    }
    if (idTipoUsuario === 4) {
      path = "/prep/motorista/";
    }
    if (idTipoUsuario === 5) {
      path = "/prep/usina/";
    }
  }
  // const path = selectRoute()
  async function handleLogin(values) {
    setShowLoading(true);
    const response = await signIn(values);
    if (response.data.error === 0) {
      console.log(path);
      navigate(path);
      return;
    }
    // Mostrar alerta caso ocorra erro no servidor
    // if (response.request.status === 500 || response.request.status === 502) {
    //   setShowLoading(false);
    //   showAlert(1, "Um erro de servidor aconteceu, entre em contato com o suporte");
    // }

    setShowLoading(false);
    showAlert(1, response.data?.msgError);
  }

  useEffect(() => {
    if (expired) {
      return logout();
    }
    // else {
    //   if (path !== null) {
    //     navigate(path)
    //   }
    // }
    navigate(path);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [path]);

  // Validação Formik
  const SignupSchema = Yup.object().shape({
    login: Yup.string().required("*Campo Obrigatório"),
    password: Yup.string().required("*Campo Obrigatório"),
  });

  return (
    <div className={styles.container}>
      <section className={styles.section_login}>
        <img src="assets/logo.png" alt="Triangulo Logo" />
        <h3>
          Gerenciamento de <br /> Oléos e Gorduras <br /> Residuais
        </h3>

        <Formik
          initialValues={{
            login: "",
            password: "",
          }}
          validationSchema={SignupSchema}
          onSubmit={async (values) => handleLogin(values)}
        >
          {({ errors, touched }) => (
            <Form>
              <div className={styles.form}>
                <Field
                  name="login"
                  type="text"
                  placeholder="Login"
                  className={styles.input}
                />
                {errors.login && touched.login ? (
                  <span className={styles.alertError}>{errors.login}</span>
                ) : null}
                <Field
                  name="password"
                  type="password"
                  placeholder="Senha"
                  className={styles.input}
                />
                {errors.password && touched.password ? (
                  <span className={styles.alertError}>{errors.password}</span>
                ) : null}
                <Loading display={showLoading && !erro ? "block" : "none"} />
                <Button
                  type="submit"
                  title="Login"
                  display={showLoading && !erro ? "none" : "block"}
                />
                <span className={styles.version}>
                  {process.env.REACT_APP_VERSION}
                  {atualizarVersao && (
                    <div className={styles.container_novaVersao}>
                      Existe uma nova versão. <br /> Pressione CTRL + R para
                      atualizar
                    </div>
                  )}
                </span>
              </div>
            </Form>
          )}
        </Formik>
      </section>
    </div>
  );
}
